// this mutator is needed for deleteConversationItemParts
import '../mutators/tryRemoveFromMailStoreItemsMutator';

import loadFolderForest from 'owa-mail-folder-forest-actions/lib/actions/loadFolderForest';
import { initializeTablesInCache } from 'owa-mail-list-actions/lib/actions/helpers/tableCache/updateTablesInCache';
import { initializeMailLayout } from 'owa-mail-layout';
import { initializeInboxPlus } from 'owa-mail-inbox-plus-actions';
import { isInAnyInboxPlusTreatment } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';
import { conversationCache, mailStore } from 'owa-mail-store';
import deleteConversationItemParts from 'owa-mail-store-actions/lib/actions/deleteConversationItemParts';

export default function initializeMailModuleState() {
    // Passing a delegate here as the delete callback to allow deleteConversationItemParts to be fully loaded by webpack.
    conversationCache.initialize(mailStore.conversations, key => {
        deleteConversationItemParts(key);
    });

    if (isInAnyInboxPlusTreatment()) {
        initializeInboxPlus();
    }
    initializeTablesInCache();
    loadFolderForest();

    initializeMailLayout();
}
